const materialTheme = (mode) => {
  if(mode === 'dark'){
    return ({
      palette: {
        mode: mode,
        primary: {
          main: '#1976D2',
          light: '#4791DB',
          dark: '#115293',
          contrastText: '#fff'
        },
        secondary: {
          main: '#18C499',
          light: '#38FFCD',
          dark: '#07785C',
          contrastText: '#000000EE'
        },
        error: {
          main: '#F44336',
          light: '#E57373',
          dark: '#D32F2F',
          contrastText: '#fff'
        },
        warning: {
          main: '#FF9800',
          light: '#FFB74D',
          dark: '#F57C00',
          contrastText: '#000000EE'
        },
        info: {
          main: '#C450D9',
          light: '#EB78FF',
          dark: '#5D1C69',
          contrastText: '#fff'
        },
        success: {
          main: '#71D927',
          light: '#99E364',
          dark: '#50991C',
          contrastText: '#000000EE'
        },
        comp: {
          tableBg: '#00001188',
          tableHeaderBg: '#000011FF',
          boxBorder: '#555577',
          boxBg: '#00001188',
          spColor1: '#ffa28b',
          spColor2: '#ab9ff5',
          navbarBg: '#1E2850',
          gray: '#AAAACC',
        },
        background: {
          default: '#0d1117',
          paper: '#161b22',
        },
        text: {
          primary: '#fff',
          secondary: '#FFFFFFBB',
          disabled: '#FFFFFF88',
          hint: '#FFFFFF88',
        },
      },
      shape: {
        borderRadius: 20,
      }
    })
  }  else {
    return ({
      palette: {
        mode: mode,
        primary: {
          main: '#0040a0',
          light: '#88a9ff',
          dark: '#001847',
          contrastText: '#fff'
        },
        secondary: {
          main: '#9c5bc0',
          light: '#e6b4ff',
          dark: '#743598',
          contrastText: '#fff'
        },
        error: {
          main: '#D8362A',
          light: '#E67D75',
          dark: '#93000a',
          contrastText: '#fff'
        },
        warning: {
          main: '#FFB60A',
          light: '#FFDA85',
          dark: '#E09D00',
          contrastText: '#523900'
        },
        info: {
          main: '#00c4ab',
          light: '#02f7d5',
          dark: '#008f7b',
          contrastText: '#FFF'
        },
        success: {
          main: '#63BE23',
          light: '#99E364',
          dark: '#488A19',
          contrastText: '#FFF'
        },
        greenDark: {
          main: '#34950a',
          light: '#4daa17',
          dark: '#007300',
          contrastText: '#FFF'
        },
        comp: {
          tableBg: '#fafafa',
          tableHeaderBg: '#e0e0ff',
          areaBackground: '#f5f5f5',
          boxBorder: '#555577',
          boxBg: '#0000990B',
          spColor1: '#FF8A8C',
          spColor2: '#6E59FD',
          navbarBg: '#FAFAFF',
          gray: '#8888AA',
        },
        background: {
          default: '#FAFAFF',
          paper: '#fffbff',
        },
        text: {
          primary: '#1c1b1e',
          secondary: '#7a757f',
        },
      },
      shape: {
        borderRadius: 20,
      }
    })
  }
}

export default materialTheme;